<div class="py-2">
  <h2 class="font-semibold mb-4 text-[16px]">Заказы</h2>
  <tui-accordion [rounded]="false">
    @for (
      order of preparedOrders$ | async;
      track order.original.id;
      let index = $index
    ) {
      <tui-accordion-item borders="top-bottom" [showArrow]="false">
        <div class="flex gap-x-2 py-1.5 pr-1.5">
          <div class="w-[40px] rounded-xl bg-purple-200 text-center">
            {{ index + 1 }}
          </div>
          <div class="w-[250px] overflow-hidden disappearing">
            {{ order.original.clientJson.name }}
          </div>

          <div class="w-[250px] overflow-hidden disappearing">
            {{ order.original.clientAddressWithCoordinatesJson.address }}
          </div>
          <div class="w-[250px] overflow-hidden disappearing flex items-center">
            {{ order.original.farmJson.name }}
            @if (order.original.farmJson.taxNonPayer) {
              <tui-svg
                tuiHint="Неплательщик НДС"
                class="text-red-500"
                src="tuiIconDollarSign"
              ></tui-svg>
            }
          </div>

          <div class="w-[150px] overflow-hidden disappearing">
            {{ order.computed.flowerTypeName }}
          </div>
          <div class="w-[150px] overflow-hidden disappearing">
            {{ order.computed.packages }} BX
          </div>
          <div class="w-[150px] overflow-hidden disappearing">
            {{ order.computed.places }}
          </div>
        </div>

        <ng-template tuiAccordionItemContent>
          <app-order [order]="order.original"></app-order>
        </ng-template>
      </tui-accordion-item>
    }
  </tui-accordion>
</div>
